"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.nullToUndefined = exports.safeJoin = exports.decodeEntities = void 0;
function decodeEntities(encodedString) {
    const translateFrom = /&(nbsp|amp|quot|lt|gt);/g;
    const translate = {
        nbsp: ' ',
        amp: '&',
        quot: '"',
        lt: '<',
        gt: '>',
    };
    return encodedString
        .replace(translateFrom, (match, entity) => translate[entity])
        .replace(/&#(\d+);/gi, (match, numStr) => {
        const num = parseInt(numStr, 10);
        return String.fromCharCode(num);
    });
}
exports.decodeEntities = decodeEntities;
function safeJoin(value1, value2) {
    return [value1, value2].join(' ').trim();
}
exports.safeJoin = safeJoin;
const nullToUndefined = (value) => {
    return value === null ? undefined : value;
};
exports.nullToUndefined = nullToUndefined;
//# sourceMappingURL=common.js.map